import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import axios from 'axios'
import { AuthProvider } from './context/AuthContext'
import App from './App'
import ErrorBoundary from './shared/ErrorBoundary'
import { installGlobalErrorReporting, attachAxiosInterceptor } from './shared/errorReporting'
import './index.css'

installGlobalErrorReporting();
attachAxiosInterceptor(axios);

// NOTE: no auto-reload on new deployments. A background poller used to call
// window.location.reload() ~2 min after every deploy, which refreshed the portal
// under users mid-edit. New builds are picked up on the next manual navigation /
// refresh instead (index.html is served no-cache; assets are content-hashed).
// If an on-demand chunk (PDF / ZIP libraries) from an older build is gone, ask
// the user instead of reloading underneath them.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  if (window.confirm('The Letter Portal was updated. Reload the page to continue?\n\n(Click Cancel first if you have unsaved changes.)')) {
    window.location.reload();
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  </ErrorBoundary>,
)
